
export default class CommonFileListItem {
    constructor(
        public readonly id: number,
        public readonly name: string,
        public readonly createdByName: string,
        public readonly createdAt: moment.Moment,
        public readonly category: string,
    ) { }
}